import { HOMEPAGE_REORDERING_092724 } from "@faire/web-api/indigofair/settings/HOMEPAGE_REORDERING_092724";
import { IThreeVariantXP } from "@faire/web-api/indigofair/settings/IThreeVariantXP";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingHomepageReordering = (): {
  isReorderVariant: boolean;
  isNewCopyVariant: boolean;
} => {
  const setting = useSetting(
    HOMEPAGE_REORDERING_092724,
    IThreeVariantXP.Bucket.CONTROL
  );
  return {
    isReorderVariant:
      setting === IThreeVariantXP.Bucket.VARIANT_3 ||
      setting === IThreeVariantXP.Bucket.VARIANT_2,
    isNewCopyVariant: setting === IThreeVariantXP.Bucket.VARIANT_3,
  };
};

export const useAssignSettingHomepageReordering = () =>
  useAssignSetting(HOMEPAGE_REORDERING_092724);
